"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { enUS, es, pt } from "date-fns/locale";
import { Calendar } from "../Calendar/index.js";
import { Popper, PopperContent, PopperTrigger } from "../Popper/index.js";
import { DateInput } from "./components/DateInput/index.js";
function DatePicker({ id, selected, onSelect, mode, modifiers, language, disabled, month, onMonthChange, defaultMonth, triggerClassName, disabledDays, removePortal, yearDropdown, fromYear, toYear, footer, ...inputProps }) {
    const locale = 'en' === language ? enUS : 'pt' === language ? pt : es;
    return /*#__PURE__*/ jsxs(Popper, {
        children: [
            /*#__PURE__*/ jsx(PopperTrigger, {
                disabled: disabled,
                className: triggerClassName,
                children: /*#__PURE__*/ jsx(DateInput, {
                    mode: mode,
                    selected: selected,
                    disabled: disabled,
                    ...inputProps,
                    rootElement: "div"
                })
            }),
            /*#__PURE__*/ jsxs(PopperContent, {
                className: "tw-w-auto tw-shadow-none",
                removePadding: true,
                removePortal: removePortal,
                children: [
                    'single' === mode && /*#__PURE__*/ jsx(Calendar, {
                        id: id,
                        mode: mode,
                        selected: selected,
                        onSelect: onSelect,
                        locale: locale,
                        initialFocus: true,
                        modifiers: modifiers,
                        month: month,
                        onMonthChange: onMonthChange,
                        defaultMonth: defaultMonth,
                        yearDropdown: yearDropdown,
                        fromYear: fromYear,
                        toYear: toYear,
                        disabled: disabledDays,
                        footer: footer
                    }),
                    'range' === mode && /*#__PURE__*/ jsx(Calendar, {
                        id: id,
                        mode: mode,
                        selected: selected,
                        onSelect: onSelect,
                        locale: locale,
                        initialFocus: true,
                        modifiers: modifiers,
                        month: month,
                        onMonthChange: onMonthChange,
                        defaultMonth: defaultMonth,
                        yearDropdown: yearDropdown,
                        fromYear: fromYear,
                        toYear: toYear,
                        disabled: disabledDays,
                        footer: footer
                    })
                ]
            })
        ]
    });
}
export { DatePicker };
